import { useQuery } from "@tanstack/react-query";
import { listProviders } from "./providersApi";

export const useProviders = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["providers"],
    queryFn: ({ signal }) => listProviders(signal),
  });

  return { providers: data ?? [], isLoading };
};
